// extracted by mini-css-extract-plugin
export var label = "_fq-0";
export var treatmentCard = "_fq-1";